export default __webpack_public_path__ + "static/media/photo_5282747746622312915_y.d85b1d85.jpg";